const { createConstant } = require("../../helpers");

const service = "market/delivery";

module.exports = {
  LIST_PROVIDERS: createConstant(service, "LIST_PROVIDERS"),
  LIST_PROVIDERS_SUCCESS: createConstant(service, "LIST_PROVIDERS_SUCCESS"),
  LIST_PROVIDERS_ERROR: createConstant(service, "LIST_PROVIDERS_ERROR"),
  LIST_PROVIDERS_RESET: createConstant(service, "LIST_PROVIDERS_RESET"),

};
